import { CompanyQuestionAnswerList } from "@/components/non_registrant/company-question-answer-list";
import { DashboardParties } from "@/components/non_registrant/dashboard-parties";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { listCompanyQuestionTabs } from "@/hera-api/company-question-answers-api";
import type { HelpPortalId } from "@/lib/help-portal";
import { useQuery } from "@tanstack/react-query";
import type { ReactNode } from "react";

const PARTIES_TAB = "parties";

interface PartiesSetupSectionProps {
  isAuthSetupComplete: boolean;
  showImpersonateButton?: boolean;
  helpPortal?: HelpPortalId;
  pageChrome: ReactNode;
  partiesTab: string;
  onPartiesTabChange: (tab: string) => void;
}

export function PartiesSetupSection({
  isAuthSetupComplete,
  showImpersonateButton = false,
  helpPortal,
  pageChrome,
  partiesTab,
  onPartiesTabChange,
}: PartiesSetupSectionProps) {
  const tabsQuery = useQuery({
    queryKey: ["company-question-tabs"],
    queryFn: listCompanyQuestionTabs,
  });
  const questionTabs = tabsQuery.data ?? [];
  const active =
    partiesTab === PARTIES_TAB ||
    questionTabs.some((tab) => tab.key === partiesTab)
      ? partiesTab
      : PARTIES_TAB;

  return (
    <Tabs
      value={active}
      onValueChange={onPartiesTabChange}
      className="flex min-h-0 flex-1 flex-col"
    >
      <TabsList className="mb-2 h-auto w-full shrink-0 flex-wrap justify-start">
        <TabsTrigger value={PARTIES_TAB}>Parties</TabsTrigger>
        {questionTabs.map((tab) => (
          <TabsTrigger key={tab.key} value={tab.key}>
            {tab.label}
          </TabsTrigger>
        ))}
      </TabsList>
      <TabsContent
        value={PARTIES_TAB}
        className="mt-0 flex min-h-0 flex-1 flex-col"
      >
        <DashboardParties
          isAuthSetupComplete={isAuthSetupComplete}
          showImpersonateButton={showImpersonateButton}
          canWriteParties
          helpPortal={helpPortal}
          leadingContent={<div className="pb-4">{pageChrome}</div>}
        />
      </TabsContent>
      {questionTabs.map((tab) => (
        <TabsContent
          key={tab.key}
          value={tab.key}
          className="mt-0 flex min-h-0 flex-1 flex-col"
        >
          <CompanyQuestionAnswerList
            tabKey={tab.key}
            leadingContent={<div className="pb-4">{pageChrome}</div>}
          />
        </TabsContent>
      ))}
    </Tabs>
  );
}
